export async function insertText(text: string) {
  try {
    await Word.run(async (context) => {
      const range = context.document.getSelection();
      range.insertText(text, Word.InsertLocation.replace);
      await context.sync();

      // Une frappe est envoyée par l'enregistrement automatique. Une insertion du complément ne l'est pas.
      context.document.save();
      await context.sync();
    });
  } catch (error) {
    console.log("Error: " + error);
  }
}

export async function getSelectedText () {
  try {
    return await Word.run(async (context) => {
      const range = context.document.getSelection();
      range.load("text");
      await context.sync();
      return range.text;
    });
  } catch (error) {
    console.log("Error retrieving selected text: " + error);
    return "";
  }
};
